import {Brick, registerBrick} from 'olympe';

/**
 * This brick builds the structure for Olympe Gateway update body with specific data and filters.
 */
export default class OGCreateUpdateEndpointBody extends Brick {
    /**
     * @override
     * @protected
     * @param {!BrickContext} $
     * @param {*} dataToUpdate
     * @param {*} filters
     * @param {function({data: []})} setBody
     */
    update($, [dataToUpdate, filters], [setBody]) {
        setBody({
            data: [
                {
                    update: Object.entries(dataToUpdate).map(([key, value]) => ({[key]: value})),
                    filters: Object.entries(filters).map(([key, value]) => ({
                        field: key,
                        value: value,
                    })),
                },
            ],
        });
    }
}

registerBrick('019c2d0a5c71bc5046db', OGCreateUpdateEndpointBody);
